var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilmStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.5V25.25C7 25.7563 7.41041 26.1667 7.91667 26.1667H28.0833C28.5896 26.1667 29 25.7563 29 25.25V8.75004C29 8.24378 28.5896 7.83337 28.0833 7.83337H26",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84615 4H25.1538C25.6435 4 26.1131 4.19156 26.4593 4.53253C26.8055 4.87351 27 5.33597 27 5.81818V22.1818C27 22.664 26.8055 23.1265 26.4593 23.4675C26.1131 23.8084 25.6435 24 25.1538 24H4.84615C4.35652 24 3.88695 23.8084 3.54073 23.4675C3.1945 23.1265 3 22.664 3 22.1818V5.81818C3 5.33597 3.1945 4.87351 3.54073 4.53253C3.88695 4.19156 4.35652 4 4.84615 4ZM25.1538 5.81818H21.4615V7.63636H25.1538V5.81818ZM19.6154 5.81818H15.9231V7.63636H19.6154V5.81818ZM14.0769 5.81818H10.3846V7.63636H14.0769V5.81818ZM4.84615 22.1818H8.53846V20.3636H4.84615V22.1818ZM4.84615 7.63636H8.53846V5.81818H4.84615V7.63636ZM10.3846 20.5114V22.1818H14.0769V20.5114H10.3846ZM15.9231 20.5114V22.1818H19.6154V20.5114H15.9231ZM21.4615 22.1818H25.1538V20.3636H22.5231V20.5114H21.4615V22.1818ZM14.4141 12.0463L16.8682 13.7366C16.9084 13.7639 16.9417 13.8026 16.9648 13.8487C16.9879 13.8949 17 13.947 17 14C17 14.053 16.9879 14.1051 16.9648 14.1513C16.9417 14.1974 16.9084 14.2361 16.8682 14.2634L14.4141 15.9537C14.3732 15.9829 14.326 15.9989 14.2777 15.9999C14.2293 16.001 14.1816 15.987 14.1397 15.9595C14.0973 15.9332 14.0619 15.8945 14.0373 15.8475C14.0128 15.8004 13.9999 15.7468 14 15.6922V12.3078C13.9999 12.2532 14.0128 12.1996 14.0373 12.1525C14.0619 12.1055 14.0973 12.0668 14.1397 12.0405C14.1816 12.013 14.2293 11.999 14.2777 12.0001C14.326 12.0011 14.3732 12.0171 14.4141 12.0463Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmStrip);
export default __webpack_public_path__ + "static/media/FilmStrip.8e5e3ac61766ac90bc8110f92fdbf5cf.svg";
export { ForwardRef as ReactComponent };